import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withFirebase} from '../../../../Firebase';
import {
  ADD_UPLOADED_TOPIC_TYPE_TAG
} from '../constants/constants';
import { t } from 'i18next';
import { 
  UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/UploadDataTopicDetailsModali18nConstants';
import BasicTopicDetailsForm from './BasicTopicDetailsForm';

const initialState = {
  topicName: '',
  description: '',
  categories: [],
  status: false,
  hasUploadedData: false,
  hasCrawledData: false
};

class UploadDataTopicDetailsModal extends Component {
  static propTypes = {
    show:                                       PropTypes.bool.isRequired,
    toggleModal:                                PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
    createTopics:                               PropTypes.func.isRequired,
    allCategories:                              PropTypes.array.isRequired,
    resetAddTopicForm:                          PropTypes.bool.isRequired,
    createTopicsBeginStatus:                    PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
    allTopicNames:                              PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      error: {},
      topicData: JSON.parse(JSON.stringify(initialState)),
      allTopicNames: [],
      sendEmailWhenReady: false
    };
  }

  componentDidMount() {
    this.setState({ allTopicNames: this.props.allTopicNames});

    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  static getDerivedStateFromProps(nextProps, prevState){
    let update = {};

    if (nextProps.resetAddTopicForm) {
      update.topicData = JSON.parse(JSON.stringify(initialState));
      update.error = {};
    }

    if (nextProps.allTopicNames && nextProps.allTopicNames.length) {
      if (JSON.stringify(nextProps.allTopicNames) !== JSON.stringify(prevState.allTopicNames)) {
        update.allTopicNames = nextProps.allTopicNames;
      }
    }
    return update;
  }

  render() {
    const {
      toggleModal,
      show,
      createTopicsBeginStatus,
      allCategories,
      allTopicNames
    } = this.props;

    return (
      <div className={`modal create-upload-data-topic-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="modal-dialog">
          <div className="modal-content"> 
              <div className="modal-header">
                <div className="step-container">
                  <div className="circle">
                    <p>{this.getI18nText(MY_I18N_KEYS.step_one)}</p>
                  </div>
                  <span className="create-upload-data-topic-modal-title">
                    {this.getI18nText(MY_I18N_KEYS.modal_title)}
                  </span>
                </div>
                <button
                  onClick={() => toggleModal(false)}
                  onKeyDown={() => {}}
                >
                  <i className="la la-close modal-close"/>    
                </button>
              </div>
                <BasicTopicDetailsForm
                  createTopics={e => this.props.createTopics(e)}
                  allCategories={allCategories}
                  resetAddTopicForm={this.props.resetAddTopicForm}
                  createOrUpdateTopicsBeginStatus={createTopicsBeginStatus}
                  allTopicNames={allTopicNames}
                  toggleModal={this.props.toggleModal}
                  type={ADD_UPLOADED_TOPIC_TYPE_TAG}
                />
          </div>
        </div>
      </div>
    );
  }
}

export default withFirebase(UploadDataTopicDetailsModal);



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/UploadDataTopicDetailsModal.js